module.exports = __webpack_public_path__ + "static/media/terms.b25f3c14.svg";